import PropTypes from 'prop-types';

export default {
  apiUrl: PropTypes.string.isRequired,
};
